module.exports = __webpack_public_path__ + "static/contact-1-1-5311864a92b3c485d8eedc839eca4c4c.jpg";